import Router from '@/router';
import Store from '@/store';
import Axios from 'axios';
import api from '@/api';
import JWTDecode from 'jwt-decode';

let authenticated = true;
let decodedToken;

export default {

	async authenticate (options) {

		console.log('Authenticating...');

		let token;

		// reauth
		if (!options) {

			console.log('With token...');

			token = this.getToken();

			if (!token) {
				this.logout();
				return false;
			}
		}

		try {
			let response;
			if (!options) response = await api.auth.reauthenticate(token);
			else response = await api.auth.authenticate(options.username, options.password);
			await this.onAuthentication(response);

			return true;

		} catch (error) {
			throw error;
		}

	},

	async onAuthentication (response) {

		console.log('Authenticated!');

		const token = response.data.jwt;
		authenticated = true;
		decodedToken = JWTDecode(response.data.jwt);

		localStorage.setItem('asc-coaching-reports', token);
		Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
		await Store.dispatch('getCurrentUser', decodedToken.uuid);
	},

	logout: function () {
		authenticated = false;
		localStorage.removeItem('asc-coaching-reports');
		Axios.defaults.headers.common['Authorization'] = null;
		Store.dispatch('removeCurrentUser');
		Router.push('/login');
	},

	isAuthenticated: function () {
		return authenticated;
	},

	getToken: function () {
		return localStorage.getItem('asc-coaching-reports');
	},

	getDecodedToken: function () {
		return decodedToken;
	}
};



// WEBPACK FOOTER //
// ./src/services/Auth.js